import { UseQueryOptions } from 'react-query';
import { HttpError } from '@frontend/fetch';
import { useQuery } from '@frontend/react-query-helpers';
import { fetchDataSources, fetchSyncAppAuthCheck } from './api';
import {
  LocationDataSourcesRequest,
  LocationDataSourcesResponse,
  SyncAppAuthCheckData,
  SyncAppAuthCheckRequest,
} from './types';

const BASE_QUERY_KEY = 'syncApp';

export const SyncAppQueryKeys = {
  syncAppAuthCheck: (request: SyncAppAuthCheckRequest) => [BASE_QUERY_KEY, 'authCheck', request.locationId],
  locationDataSources: (request: LocationDataSourcesRequest) => [BASE_QUERY_KEY, 'dataSources', request.locationId],
};

export function useSyncAppAuthCheck<TData = SyncAppAuthCheckData>(
  request: SyncAppAuthCheckRequest,
  options?: UseQueryOptions<SyncAppAuthCheckData, HttpError, TData>
) {
  return useQuery({
    queryKey: SyncAppQueryKeys.syncAppAuthCheck(request),
    queryFn: () => fetchSyncAppAuthCheck(request),
    retry: false,
    ...options,
    enabled: !!request.locationId && (options?.enabled ?? true),
  });
}

export function useLocationDataSources<TData = LocationDataSourcesResponse>(
  request: LocationDataSourcesRequest,
  options?: UseQueryOptions<LocationDataSourcesResponse, HttpError, TData>
) {
  return useQuery({
    queryKey: SyncAppQueryKeys.locationDataSources(request),
    queryFn: () => fetchDataSources(request),
    retry: false,
    ...options,
    enabled: !!request.locationId && (options?.enabled ?? true),
  });
}
